"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));
/**
 * Simple queue
 */
var SimpleQueue = /*#__PURE__*/function () {
  /**
   * @constructs SimpleQueue
   */
  function SimpleQueue() {
    (0, _classCallCheck2.default)(this, SimpleQueue);
    (0, _defineProperty2.default)(this, "queue", void 0);
    this.queue = [];
  }

  /**
   * Removes all of the elements from queue.
   * @returns {undefined}
   */
  (0, _createClass2.default)(SimpleQueue, [{
    key: "clear",
    value: function clear() {
      this.queue = [];
    }

    /**
     * Inserts the specified element into the queue.
     * @param {object} item
     * @returns {undefined}
     */
  }, {
    key: "enqueue",
    value: function enqueue(item) {
      this.queue.push(item);
    }

    /**
     * Returns and removes the head of the queue.
     * Returns null if the queue is empty.
     * @returns {(object|null)} Queue item or null.
     */
  }, {
    key: "dequeue",
    value: function dequeue() {
      if (this.queue.length === 0) {
        return null;
      }
      return this.queue.shift();
    }

    /**
     * Returns the number of items in queue.
     * @returns {number}
     */
  }, {
    key: "size",
    value: function size() {
      return this.queue.length;
    }
  }]);
  return SimpleQueue;
}();
exports.default = SimpleQueue;
//# sourceMappingURL=queue.js.map
